<template>
  <div class="py-4">
    <div class="row">
      <div class="col-lg-12">
        <div class="row">
          <div class="col-xl-5">
            <div class="product-detai-imgs" style="margin-bottom: 1rem">
              <img
                  :src="productInfo.thumbnail"
                  alt
                  class="img-fluid mx-auto d-block"
              />
            </div>
            <div class="button_outer" v-if="!loading">
              <div class="btn_upload" >
                <input type="file" id="upload_file" @change="uploadImage">
                Upload Image
              </div>
            </div>
            <div v-else style="position: relative;">
              <div class="spinner-grow text-secondary" style="margin-right: .5rem" role="status">
                <span class="sr-only">Loading...</span>
              </div>
              <div class="spinner-grow text-secondary" style="margin-right: .5rem" role="status">
                <span class="sr-only">Loading...</span>
              </div>
              <div class="spinner-grow text-secondary" style="margin-right: .5rem" role="status">
                <span class="sr-only">Loading...</span>
              </div>
              <div class="spinner-grow text-secondary" style="margin-right: .5rem" role="status">
                <span class="sr-only">Loading...</span>
              </div>
            </div>
            <div class="my-5">
              <div class="mb-4 h5"><b>Description:</b></div>
              <p class="text-muted mb-4" v-html="productInfo.description"></p>
            </div>
          </div>
          <div class="col-xl-7">
            <div class="mt-3">
              <h1 class="mt-1 mb-0 text-primary">
                {{ productInfo.officialProductName }}
              </h1>
              <div class="mb-2" style="font-size: medium">
                <span class="text-decoration-underline text-success" v-if="productInfo.availableForOrder">
                  Available for Order Placement
                </span>
                <span class="text-decoration-underline text-danger" v-else>
                  Not Available for Order Placement
                </span>
              </div>

              <div class="row mt-5 h5">
                <div class="col-5 mb-4"><b>Official Product Name:</b></div>
                <div class="col-6 mb-4">{{ productInfo.officialProductName }}</div>
                <div class="col-5 mb-4"><b>Product Name:</b></div>
                <div class="col-6 mb-4">{{ productInfo.productName }}</div>
                <div class="col-5 mb-4"><b>Product Code:</b></div>
                <div class="col-6 mb-4">{{ productInfo.code }}</div>
                <div class="col-5 mb-4"><b>Abbreviation:</b></div>
                <div class="col-6 mb-4">{{ productInfo.abbreviation }}</div>
                <div class="col-5 mb-4"><b>ITF Code:</b></div>
                <div class="col-6 mb-4">{{ productInfo.itfcode }}</div>
                <div class="col-5 mb-4"><b>JAN Code:</b></div>
                <div class="col-6 mb-4">{{ productInfo.jancode }}</div>
                <div class="col-5 mb-4"><b>Expiry Period:</b></div>
                <div class="col-6 mb-4">{{ productInfo.expiryPeriod }} months</div>
                <div class="col-5 mb-4"><b>M3:</b></div>
                <div class="col-6 mb-4">{{ productInfo.m3 }}</div>
                <div class="col-5 mb-4"><b>Minimum Order Unit:</b></div>
                <div class="col-6 mb-4">{{ productInfo.minimumOrderUnit }}</div>
                <div class="col-5 mb-4"><b>Volume:</b></div>
                <div class="col-6 mb-4">{{productInfo.volume}}</div>
                <div class="col-5 mb-4"><b>Quantity Per Order Unit:</b></div>
                <div class="col-6 mb-4">{{productInfo.qpoUnit}}</div>
                <div class="col-5 mb-4"><b>Quantity Per Case:</b></div>
                <div class="col-6 mb-4">{{ productInfo.quantityPerCase }}</div>
              </div>
              <div class="row my-4">
                <div class="col-sm-4 text-center">
                  <h5 class="font-size-15 fw-bold">Weight Per C/S</h5>
                  <p class="text-muted mb-2">{{ productInfo.caseWeight }}</p>
                </div>
                <div class="col-sm-4 text-center">
                  <h5 class="font-size-15 fw-bold">Weight Per Ball</h5>
                  <p class="text-muted mb-2">{{ productInfo.bowlWeight }}</p>
                </div>
                <div class="col-sm-4 text-center">
                  <h5 class="font-size-15 fw-bold">	Weight Per P/C</h5>
                  <p class="text-muted mb-2">{{ productInfo.unitWeight }}</p>
                </div>
              </div>
              <hr style="border-top: 5px double #8c8b8b;"/>
              <div class="prices">
                <div class="mt-5" v-for="tier in tiers.objects" :key="tier.publicId">
                  <h5 class="mb-3">{{ tier.name }} :</h5>
                  <div class="table-responsive w-50">
                    <table class="table mb-0 table-bordered">
                      <tbody>
                      <tr>
                        <th v-if="getTierOrderUnit(productInfo.pricing) === 'C/S'">Basic C/S Price</th>
                        <th v-else-if="getTierOrderUnit(productInfo.pricing) === 'Ball'">Basic Ball Price</th>
                        <th v-else-if="getTierOrderUnit(productInfo.pricing) === 'PCs'">Basic P/C Price</th>
                      </tr>
                      <tr>
                        <td>{{getTierPrice(productInfo.pricing, tier.publicId)}}</td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {ALL_CUSTOMER_TIERS} from "@/gql";
import {errorToast, successToast} from "@/components/successToast";
import {mapActions} from "vuex";

export default {
name: "product-information",
  data(){
    return{
      tiers: {
        objects: []
      },
      loading: false
    }
  },
  props: {
    productInfo: {
      type: Object,
      default(){
        return {
          publicId: "",
          thumbnail: "",
          description: "",
          officialProductName: "",
          productName: "",
          code: "",
          abbreviation: "",
          itfcode: "",
          jancode: "",
          expiryPeriod: "",
          m3: "",
          minimumOrderUnit: "",
          volume: "",
          qpoUnit: "",
          quantityPerCase: "",
          caseWeight: "",
          bowlWeight: "",
          unitWeight: "",
          pricing: {}
        }
      }
    }
  },
  apollo: {
    tiers: {
      query: ALL_CUSTOMER_TIERS,
      variables(){
        return {
          page: 1,
          perPage: 30
        }
      }
    }
  },
  methods: {
    ... mapActions({
      uploadProductImage: 'http/uploadProductImage',
    }),
    getTierPrice(pricing, tierId){
      let value = 0;
      if (pricing != undefined) {
        Object.entries(pricing).forEach(([key, number]) => {
          if (key === tierId) {
            for (const i in number) {
              value = number[i]
            }
          }
        });
      }
      return value
    },
    getTierOrderUnit(pricing){
      let value;
      if (pricing != undefined){
        Object.values(pricing).forEach((number) => {
          for(const i in number){
            value = i
          }
        });
      }
      return value
    },
    async uploadImage(e){
      this.loading = true
      const formData = new FormData()
      formData.append('file', e.target.files[0])
      formData.append('product_id', this.productInfo.publicId)
      const response = await this.uploadProductImage(formData)
      if(response.data.message === "The image has been uploaded successfully" || response.status === 200){
        successToast(response.data.message)
        this.$emit('refetchProduct')
      }else {
        errorToast('Error uploading image')
      }
      this.loading = false
    },
  }
}
</script>

<style scoped>
.button_outer {
  background: #FFA60D;
  border-radius: 0.25rem;
  text-align: center;
  height: 50px;
  width: 75%;
  display: inline-block;
  transition: 0.2s;
  position: relative;
  overflow: hidden;
}
.btn_upload {
  padding: 17px 30px 12px;
  color: #fff;
  text-align: center;
  position: relative;
  display: inline-block;
  overflow: hidden;
  z-index: 3;
  white-space: nowrap;
}
.btn_upload input {
  position: absolute;
  width: 100%;
  left: 0;
  top: 0;
  width: 100%;
  height: 105%;
  cursor: pointer;
  opacity: 0;
}
.processing_bar {
  position: absolute;
  left: 0;
  top: 0;
  width: 75%;
  height: 20px;
  border-radius: 30px;
  background: #ff6600;
  transition: 13s;
}
</style>
